import React from 'react';
import { Features } from '../../../assets/features/Features';
import { useLanguage } from '../../../context/LanguageContext';

interface ConsultProps {
  onAppointmentClick: () => void;
}

const Consult: React.FC<ConsultProps> = ({ onAppointmentClick }) => {
  const { language } = useLanguage();
  
  return (
    <section id="consult" className="vitality-section section py-5">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-5" data-aos="fade-up">
            <h2 className="fw-bold">{Features.consult.title[language]}</h2>
            <div className="divider mx-auto my-4" style={{
              width: '80px',
              height: '4px',
              background: 'var(--primary-color, #1977cc)',
              margin: '0 auto'
            }}></div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-10 mx-auto" data-aos="zoom-in" data-aos-delay="100">
            <div className="vitality-card text-center p-5 bg-white rounded shadow-sm">
              <div className="icon-box mb-4">
                <i className="fa-solid fa-heart-pulse fa-3x text-primary"></i>
              </div>
              <h3 className="mb-4">{Features.consult.subtitle[language]}</h3>
              <p className="mb-4">
                {Features.consult.description[language]}
              </p>
              <button 
                onClick={onAppointmentClick}
                className="btn btn-primary rounded-pill px-4 py-2"
              >
                <i className="bi bi-calendar-check me-2"></i>
                {Features.consult.scheduleButton[language]}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Consult; 